import Colors from '@constants/Colors';
import type { GroupPromoMetadataOutput } from '@sunrise-ui/api/events';
import {
  Button,
  ButtonVariants,
  Card,
  TextBold,
  TextReg,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import { router } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';

type Props = {
  groupPromos?: GroupPromoMetadataOutput[];
};

export function GroupPromoCards({ groupPromos }: Props) {
  const styles = useDynamicStyles(createStyles);

  const handleManageTickets = (slug: string) => {
    router.navigate(`/tickets/group/${slug}`);
  };

  if (!groupPromos?.length) {
    return null;
  }

  return (
    <View style={styles.container}>
      <TextBold style={styles.sectionTitle}>Manage Group Tickets</TextBold>
      <View style={styles.cardsContainer}>
        {groupPromos.map((promo) => (
          <Card key={promo.id} style={styles.card}>
            <View style={styles.cardContent}>
              <View style={styles.textContainer}>
                <TextBold style={styles.promoName} numberOfLines={1}>
                  {promo.name}
                </TextBold>
                {promo.description && (
                  <TextReg style={styles.description} numberOfLines={2}>
                    {promo.description}
                  </TextReg>
                )}
              </View>
              <Button
                size="small"
                variant={ButtonVariants.PURPLE}
                onPress={() => handleManageTickets(promo.slug)}
              >
                Manage
              </Button>
            </View>
          </Card>
        ))}
      </View>
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    container: {
      paddingHorizontal: isMobile ? 16 : 24,
      paddingVertical: 16,
    },
    sectionTitle: {
      fontSize: isMobile ? 18 : 20,
      marginBottom: 12,
      textAlign: 'center',
    },
    cardsContainer: {
      gap: 12,
      alignItems: 'center',
    },
    card: {
      padding: isMobile ? 16 : 20,
      maxWidth: isMobile ? undefined : 400,
    },
    cardContent: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      width: '100%',
    },
    textContainer: {
      flex: 1,
      gap: 4,
    },
    promoName: {
      fontSize: isMobile ? 16 : 18,
    },
    description: {
      fontSize: isMobile ? 13 : 14,
      color: Colors.dark.text,
      opacity: 0.7,
    },
  });
